/*
 * a11y-links.js — link-purpose repairs that apply site-wide.
 * AudioEye Aug 2026: STOR-123, COMB-133, REEL-162, HOME-22 (and the same pattern
 * wherever a phone or email link is rendered from data rather than markup).
 *
 * Telephone and email links were announced as nothing but the number or the
 * address, so there was no indication they were actionable. On the Stores page
 * these are built at runtime from the locator's data — 400 of them — so the
 * labels are applied to the rendered output rather than to a template.
 *
 * Only links whose visible text IS the raw number/address are touched: anything
 * already carrying its own label, or reading as words ("Call us"), is left alone.
 */
(function () {
  'use strict';

  function labelPhone(a) {
    if (a.dataset.a11yLink === '1') return;
    a.dataset.a11yLink = '1';
    if (a.getAttribute('aria-label')) return;
    var text = (a.textContent || '').replace(/\s+/g, ' ').trim();
    var number = (a.getAttribute('href') || '').replace(/^tel:/i, '').trim();
    /* If the visible text is the number itself, say what the link does. Keep the
       visible string inside the name so 2.5.3 (Label in Name) still holds. */
    if (text && /\d/.test(text) && text.replace(/[^\d]/g, '') === number.replace(/[^\d]/g, '')) {
      a.setAttribute('aria-label', 'Call ' + text);
    } else if (!text) {
      a.setAttribute('aria-label', 'Call ' + number);
    }
  }

  function labelEmail(a) {
    if (a.dataset.a11yLink === '1') return;
    a.dataset.a11yLink = '1';
    if (a.getAttribute('aria-label')) return;
    var text = (a.textContent || '').replace(/\s+/g, ' ').trim();
    var address = (a.getAttribute('href') || '').replace(/^mailto:/i, '').split('?')[0].trim();
    if (text && text.toLowerCase() === address.toLowerCase()) {
      a.setAttribute('aria-label', 'Email ' + text);
    } else if (!text) {
      a.setAttribute('aria-label', 'Email ' + address);
    }
  }

  /* REEL-162: every product card carries an "Add to wishlist" button with the
     same accessible name, so tabbing a collection gives the identical phrase 26
     times with nothing to say which product it acts on. The buttons are injected
     by the WishlistHero app and carry no classes of their own, so they are named
     here from the product title in their own card. */
  function nameWishlistButton(btn) {
    if (btn.dataset.a11yWishlist === '1') return;
    var card = btn.closest('.collection_wrap, .grid-item, li');
    if (!card) return;
    var titleEl = card.querySelector('.collection-product-title, .product-model, .product-title, h2, h3, h4');
    var title = titleEl ? (titleEl.textContent || '').replace(/\s+/g, ' ').trim() : '';
    if (!title) return;
    btn.dataset.a11yWishlist = '1';
    var current = (btn.getAttribute('aria-label') || '').trim();
    /* keep the existing wording, just say which product it applies to */
    btn.setAttribute('aria-label', (current || 'Add to wishlist') + ': ' + title);
  }

  /* HOME-22: the WishlistHero floating launcher is an <a href="#"> that opens a
     panel in place and never navigates, so it is announced as a link and Space
     does nothing on it. The app injects it into the page rather than an iframe,
     so it can be corrected here — the same route REEL-162 uses above. */
  function fixWishlistLauncher(a) {
    if (a.dataset.a11yLauncher === '1') return;
    a.dataset.a11yLauncher = '1';
    if (!a.getAttribute('role')) a.setAttribute('role', 'button');
    /* an anchor given role="button" must answer Space as well as Enter */
    a.addEventListener('keydown', function (e) {
      if (e.key !== ' ' && e.key !== 'Spacebar') return;
      e.preventDefault();
      a.click();
    });
  }

  function sweep() {
    var launch = document.querySelectorAll('#wishlisthero-floating-launcher-container a[href="#"]:not([data-a11y-launcher])');
    for (var k = 0; k < launch.length; k++) fixWishlistLauncher(launch[k]);
    var wl = document.querySelectorAll('button[aria-label*="wishlist" i]:not([data-a11y-wishlist])');
    for (var w = 0; w < wl.length; w++) {
      var lbl = (wl[w].getAttribute('aria-label') || '').toLowerCase();
      /* only the per-product "add" controls — not the header "view wishlist" */
      if (lbl.indexOf('add') === 0) nameWishlistButton(wl[w]);
    }
    var tel = document.querySelectorAll('a[href^="tel:"]:not([data-a11y-link])');
    for (var i = 0; i < tel.length; i++) labelPhone(tel[i]);
    var mail = document.querySelectorAll('a[href^="mailto:"]:not([data-a11y-link])');
    for (var j = 0; j < mail.length; j++) labelEmail(mail[j]);
  }

  function start() {
    sweep();
    if (!('MutationObserver' in window)) return;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () { queued = false; sweep(); });
    }).observe(document.documentElement, { subtree: true, childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
